import { restoreCartFromCookieStorage } from "./utils/cart";
import { restoreCheckoutPersonalData, restoreCheckoutShippingData } from "./utils/checkout";

export default {
  catalog: {
    widths: [],
    profiles: [],
    rims: [],
    admin: {
      orders: [],
      products: [],
      during: false,
      draftOrders: [],
      draftOrdersPending: false,
      draftOrdersError: null,
      selectedDraftOrder: null,
      createDraftOrderPending: false,
      createDraftOrderError: null,
    },
    popularSizes: [],
    popularTireSets: [],
    topSellers: [],
    limitedTimeOffers: [],
    homepagePromo: { salePercent: 0, display: null, promos: [], loaded: false },
    motoTires: [],
    motoTiresQueryKey: null,
    motoTirePairs: [],
    tirePairsQueryKey: null,
    tirePairsRequestedKey: null,
    tirePairsPending: true,
    getCreationTiresPredictedYearsForPreorder: {},
    product: null,
    productNotFound: false,
    localStockBlock: null,
    localStockBlocks: [],
    category: {
      name: "",
      seo: {
        title: "מבצעי צמיגים בספורטישופ!",
      },
    },
    currentShipment: "",
    nextShipment: "",
    nextShipmentDeadline: "",
    euContainerMode: null,
    bestOfferEANs: [],
    productPending: false,
    cart: restoreCartFromCookieStorage(),
    thankyou: false,
    stats: {
      data: {
        likes: {
          products: [],
          shops: [],
        },
      },
      visitorId: null,
    },
    shopIndex: {
      cities: [],
      shops: [],
      shop: null,
      selectedCity: "",
    },
    paymentStage: null,
    checkout: {
      sip: "install",
      cities: [],
      shops: [],
      dates: [],
      slots: [],
      selectedCityId: "",
      selectedShop: "",
      installDate: "",
      installSlot: "",
      activeStep: 0,
      shipping: restoreCheckoutShippingData(),
      personal: restoreCheckoutPersonalData(),
      payment: {},
      additionalNotes: "",
      loading: false,
      checkoutError: false,
      checkoutErrorMessage: "",
      selectedPaymentMethod: "creditcard",
      couponCode: '',
      appliedDiscount: 0,
    },
    selectedWidth: "",
    selectedProfile: "",
    selectedRim: "",
    rearSelectedWidth: "",
    rearSelectedProfile: "",
    rearSelectedRim: "",
    rearProfiles: [],
    rearRims: [],
    frontTouched: false,
    rearTouched: false,
    setSearchOpen: false,
    filters: {
      hideSets: false,
      localStockOnly: false,
      euStockOnly: false,
      setsOnly: false,
      singleTiresOnly: false,
      brands: [],
    },
    listPending: true,
    snackbar: null,
    toggleSnackbar: false,
    cartProducts: [],
    tireValidationPending: false,
    tireValidationError: null,
    tireCount: null,
    hasAvailableTires: null,
    wizardPage: {
      motorcycle: "",
      usage: "",
      kilometers: "",
      motorcycleBrand: "",
      motorcycleYear: "",
      selectedTyreType: "",
      userBikeModelToInsert: "",
      visitorName: "",
      visitorPhoneNumber: "",
      currentWizardStep: 0,
      loadingAnswers: false,
      showSuggestedTires: false,
      showLayout: false,
      motoListForGPT: null,
      tiresSuggestedByGPT: null,
      allMotoBrandsAvailable: [],
      noTiresFound: false,
      limitWizardReached: false,
      gptResponseError: false,
    },
  },
};
